import React from 'react';

const NewLoaderIcon = props => {
  const { width = 80 } = props;
  return (
    <svg
      id="truck_svg"
      width={width}
      viewBox="0 0 137 75"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <g id="smoke">
          <path
            d="M23.1554 59.9661C26.8144 58.0246 27.8396 52.7925 25.4451 48.2797C23.0507 43.767 18.1435 41.6825 14.4845 43.6239C10.8255 45.5654 9.80036 50.7975 12.1948 55.3103C14.5892 59.823 19.4965 61.9075 23.1554 59.9661Z"
            fill="#AAAAAA"
          />
          <path
            d="M11.1511 55.8676C14.4735 54.1048 15.402 49.3496 13.225 45.2467C11.048 41.1438 6.58994 39.2467 3.26758 41.0095C-0.0547743 42.7723 -0.983287 47.5275 1.19369 51.6304C3.37068 55.7333 7.82877 57.6304 11.1511 55.8676Z"
            fill="#AAAAAA"
          />
          <path
            d="M15.874 60.7147C18.084 59.5421 18.7025 56.3807 17.2555 53.6535C15.8085 50.9264 12.8439 49.6662 10.6339 50.8388C8.42386 52.0114 7.80531 55.1728 9.25232 57.9C10.6993 60.6271 13.6639 61.8873 15.874 60.7147Z"
            fill="#AAAAAA"
          />
          <path
            d="M32.64 64.23L31.44 61.96C31.44 61.96 28.34 61.74 27.02 60.12C25.7 58.5 26.72 53.12 26.72 53.12L14.66 58.44C16.978 61.0695 19.9425 63.0481 23.26 64.18C26.3 65.09 31.99 64.77 32.64 64.23Z"
            fill="#AAAAAA"
          />
          <path
            d="M11.8916 47.8963C14.5846 46.4674 15.3387 42.6158 13.5758 39.2934C11.813 35.9711 8.20087 34.4361 5.50786 35.865C2.81485 37.2939 2.06077 41.1455 3.82358 44.4679C5.58639 47.7903 9.19855 49.3252 11.8916 47.8963Z"
            fill="#AAAAAA"
          />
        </g>
        <animate
          xlinkHref="#smoke"
          attributeName="opacity"
          values="0;1;0;"
          dur="1.2s"
          repeatCount="indefinite"
        />
        <g id="truck-body">
          <path d="M34.58 61.65H30.41V64.76H34.58V61.65Z" fill="#E0E0E0" />
          <path
            d="M124.91 28.63C121 18.46 114.73 18.46 114.73 18.46H99.92V46.25H130.4C128.996 40.2523 127.161 34.3637 124.91 28.63V28.63Z"
            fill="white"
          />
          <path d="M99.92 0H32.79V61.98H99.92V0Z" fill="#C0C0C0" />
          <path
            d="M124.91 28.63C121 18.46 114.73 18.46 114.73 18.46H99.92V46.25H130.4C128.996 40.2523 127.161 34.3637 124.91 28.63V28.63ZM104.71 40.63V24.05H115.19C114.83 24.05 117.53 25.05 119.87 31.14C121.22 34.63 122.33 37.87 123.25 40.69L104.71 40.63Z"
            fill="#F4A147"
          />
          <path
            d="M136.67 54.58C136.67 58.67 133.87 61.98 130.4 61.98H106.19C102.72 61.98 99.92 58.67 99.92 54.58V48.1C99.92 44.01 102.72 40.7 106.19 40.7H130.4C133.87 40.7 136.67 44.01 136.67 48.1V54.58Z"
            fill="#F4A147"
          />
          <path d="M136.66 53.65H32.79V64.75H136.66V53.65Z" fill="#E0E0E0" />
          <path d="M136.66 56.88H32.79V59.53H136.66V56.88Z" fill="white" />
          <path d="M136.66 60.96H32.79V61.64H136.66V60.96Z" fill="white" />
          <g style={{ mixBlendMode: 'multiply' }}>
            <g style={{ mixBlendMode: 'multiply' }}>
              <path d="M99.92 0H32.79V55.98H67.92V0Z" fill="#E3D8DB" />
            </g>
          </g>
          <g style={{ mixBlendMode: 'multiply' }}>
            <g style={{ mixBlendMode: 'multiply' }}>
              <path
                d="M104.71 24.05L123.25 40.7H104.71V24.05Z"
                fill="#E3D8DB"
              />
            </g>
          </g>
          <path
            d="M131.2 40.77L130.39 40.7C130.39 40.7 129 46.85 136.66 50.46V48.1C136.67 44.33 134.29 41.23 131.2 40.77Z"
            fill="#FA753A"
          />
          <g style={{ mixBlendMode: 'multiply' }}>
            <g style={{ mixBlendMode: 'multiply' }}>
              <path
                d="M136.67 50.35H99.92V53.76H136.67V50.35Z"
                fill="#E3D8DB"
              />
            </g>
          </g>
        </g>
        <animateTransform
          xlinkHref="#truck-body"
          attributeName="transform"
          type="scale"
          from="1 0.88"
          to="1 1"
          dur="0.7s"
          repeatCount="indefinite"
        />
        <g id="left-wheel">
          <path
            d="M62.69 64.75C62.6155 66.6351 61.9883 68.4567 60.8865 69.9881C59.7848 71.5196 58.257 72.6932 56.4934 73.3631C54.7297 74.033 52.808 74.1695 50.9674 73.7557C49.1268 73.3419 47.4484 72.396 46.1412 71.0358C44.834 69.6755 43.9556 67.9609 43.6153 66.1052C43.275 64.2496 43.4878 62.3349 44.2273 60.5993C44.9668 58.8636 46.2003 57.3838 47.7743 56.3438C49.3483 55.3037 51.1934 54.7495 53.08 54.75C54.3679 54.7747 55.6383 55.0531 56.8185 55.5691C57.9987 56.0852 59.0656 56.8289 59.9581 57.7577C60.8507 58.6865 61.5514 59.7821 62.0201 60.9819C62.4889 62.1817 62.7165 63.4622 62.69 64.75Z"
            fill="#232323"
          />
          <path
            d="M53.08 71.05C56.4268 71.05 59.14 68.2339 59.14 64.76C59.14 61.2861 56.4268 58.47 53.08 58.47C49.7331 58.47 47.02 61.2861 47.02 64.76C47.02 68.2339 49.7331 71.05 53.08 71.05Z"
            fill="#F06B30"
          />
          <path
            d="M56.11 68.79C56.6678 68.79 57.12 68.3378 57.12 67.78C57.12 67.2222 56.6678 66.77 56.11 66.77C55.5522 66.77 55.1 67.2222 55.1 67.78C55.1 68.3378 55.5522 68.79 56.11 68.79Z"
            fill="#E0E0E0"
          />
          <path
            d="M50.11 68.79C50.6678 68.79 51.12 68.3378 51.12 67.78C51.12 67.2222 50.6678 66.77 50.11 66.77C49.5522 66.77 49.1 67.2222 49.1 67.78C49.1 68.3378 49.5522 68.79 50.11 68.79Z"
            fill="#E0E0E0"
          />
          <path
            d="M50.11 62.79C50.6678 62.79 51.12 62.3378 51.12 61.78C51.12 61.2222 50.6678 60.77 50.11 60.77C49.5522 60.77 49.1 61.2222 49.1 61.78C49.1 62.3378 49.5522 62.79 50.11 62.79Z"
            fill="#E0E0E0"
          />
          <path
            d="M56.11 62.79C56.6678 62.79 57.12 62.3378 57.12 61.78C57.12 61.2222 56.6678 60.77 56.11 60.77C55.5522 60.77 55.1 61.2222 55.1 61.78C55.1 62.3378 55.5522 62.79 56.11 62.79Z"
            fill="#E0E0E0"
          />
          <path
            d="M53.11 65.79C53.6678 65.79 54.12 65.3378 54.12 64.78C54.12 64.2222 53.6678 63.77 53.11 63.77C52.5522 63.77 52.1 64.2222 52.1 64.78C52.1 65.3378 52.5522 65.79 53.11 65.79Z"
            fill="#E0E0E0"
          />
        </g>
        <g id="right-wheel">
          <path
            d="M125.99 64.75C125.915 66.6351 125.288 68.4567 124.187 69.9881C123.085 71.5196 121.557 72.6932 119.793 73.3631C118.03 74.033 116.108 74.1695 114.267 73.7557C112.427 73.3419 110.748 72.396 109.441 71.0358C108.134 69.6755 107.256 67.9609 106.915 66.1052C106.575 64.2496 106.788 62.3349 107.527 60.5993C108.267 58.8636 109.5 57.3838 111.074 56.3438C112.648 55.3037 114.493 54.7495 116.38 54.75C117.668 54.7734 118.939 55.0509 120.12 55.5665C121.301 56.0821 122.368 56.8258 123.261 57.7548C124.154 58.6839 124.855 59.78 125.323 60.9804C125.791 62.1808 126.018 63.4618 125.99 64.75V64.75Z"
            fill="#232323"
          />
          <path
            d="M116.37 71.05C119.711 71.05 122.42 68.2339 122.42 64.76C122.42 61.2861 119.711 58.47 116.37 58.47C113.029 58.47 110.32 61.2861 110.32 64.76C110.32 68.2339 113.029 71.05 116.37 71.05Z"
            fill="#F06B30"
          />
          <path
            d="M119.37 68.77C119.928 68.77 120.38 68.3178 120.38 67.76C120.38 67.2022 119.928 66.75 119.37 66.75C118.812 66.75 118.36 67.2022 118.36 67.76C118.36 68.3178 118.812 68.77 119.37 68.77Z"
            fill="#E0E0E0"
          />
          <path
            d="M113.37 68.77C113.928 68.77 114.38 68.3178 114.38 67.76C114.38 67.2022 113.928 66.75 113.37 66.75C112.812 66.75 112.36 67.2022 112.36 67.76C112.36 68.3178 112.812 68.77 113.37 68.77Z"
            fill="#E0E0E0"
          />
          <path
            d="M113.37 62.77C113.928 62.77 114.38 62.3178 114.38 61.76C114.38 61.2022 113.928 60.75 113.37 60.75C112.812 60.75 112.36 61.2022 112.36 61.76C112.36 62.3178 112.812 62.77 113.37 62.77Z"
            fill="#E0E0E0"
          />
          <path
            d="M119.37 62.77C119.928 62.77 120.38 62.3178 120.38 61.76C120.38 61.2022 119.928 60.75 119.37 60.75C118.812 60.75 118.36 61.2022 118.36 61.76C118.36 62.3178 118.812 62.77 119.37 62.77Z"
            fill="#E0E0E0"
          />
          <path
            d="M116.37 65.77C116.928 65.77 117.38 65.3178 117.38 64.76C117.38 64.2022 116.928 63.75 116.37 63.75C115.812 63.75 115.36 64.2022 115.36 64.76C115.36 65.3178 115.812 65.77 116.37 65.77Z"
            fill="#E0E0E0"
          />
        </g>
        <rect x="44" y="12" width="41" height="29" fill="url(#pattern0)" />

        <g id="truck-logo" fill="none">
          <path
            d="M43 24V27.7279M43 29.238V27.7279M43 27.7279L45.6898 26.2965M50.1098 24L45.6898 26.2965M45.6898 26.2965L50.1098 29.1908"
            stroke="#F16E24"
            stroke-linecap="round"
          />
          <path
            d="M60.2 24.0942H53.7366C53.1843 24.0942 52.7366 24.542 52.7366 25.0942V26.6188M60.2 29.1592H53.7366C53.1843 29.1592 52.7366 28.7115 52.7366 28.1592V26.6188M52.7366 26.6188H59.1"
            stroke="#F16E24"
            stroke-linecap="round"
          />
          <path
            d="M73.2 29.2378V24.1572C73.2 24.1224 73.2274 24.0942 73.2621 24.0942H79.125C79.6674 24.0942 80.2088 24.362 80.3659 24.8811C80.6179 25.7131 80.2829 26.2257 80.0069 26.488C79.8316 26.6546 79.5862 26.7054 79.3443 26.7054H75.5585C75.4921 26.7054 75.471 26.7949 75.5304 26.8245L80.3569 29.2378"
            stroke="#F16E24"
            stroke-linecap="round"
          />
          <path
            d="M62.86 29.2378V24.1572C62.86 24.1224 62.8874 24.0942 62.9222 24.0942H68.7851C69.3274 24.0942 69.8688 24.362 70.026 24.8811C70.2779 25.7131 69.9429 26.2257 69.6669 26.488C69.4916 26.6546 69.2462 26.7054 69.0043 26.7054H65.2185C65.1522 26.7054 65.131 26.7949 65.1904 26.8245L70.017 29.2378"
            stroke="#F16E24"
            stroke-linecap="round"
          />
          <path
            d="M83.9 29.175H89.75C90.3023 29.175 90.75 28.7273 90.75 28.175V26.7055M90.75 24V26.7055M90.75 26.7055H84.45C83.8977 26.7055 83.45 26.2578 83.45 25.7055V24"
            stroke="#F16E24"
            stroke-linecap="round"
          />
          <path
            d="M47.0269 32.3052V33.7871C47.0269 34.0632 47.2507 34.2871 47.5269 34.2871H49.5436"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M51.2999 32.6095V34.0611C51.2999 34.2544 51.4566 34.4111 51.6499 34.4111H53.8C53.9933 34.4111 54.15 34.2544 54.15 34.0611V32.6095C54.15 32.4162 53.9933 32.2595 53.8 32.2595H51.6499C51.4566 32.2595 51.2999 32.4162 51.2999 32.6095Z"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M59.05 32.3052H56.5C56.3343 32.3052 56.2 32.4395 56.2 32.6052V33.7871C56.2 34.0632 56.4238 34.2871 56.7 34.2871H58.9C58.9552 34.2871 59 34.2423 59 34.1871V33.3647C59 33.3095 58.9552 33.2647 58.9 33.2647H57.3611"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M61.09 32.3367V34.3186"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M65.9184 32.3052H63.6455C63.3719 32.3052 63.15 32.527 63.15 32.8007V32.8007C63.15 33.0743 63.3719 33.2961 63.6455 33.2961H65.4832C65.741 33.2961 65.9499 33.5051 65.9499 33.7628V33.8044C65.9499 34.0874 65.7187 34.3159 65.4357 34.3126L63.2444 34.2871"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M67.5499 32.3052H68.96M70.37 32.3052H68.96M68.96 32.3052V34.3186"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M72.2001 32.3052V34.3815"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M74.26 32.3052V33.768M74.26 34.3815V33.768M74.26 33.768L75.35 33.2M77.1074 32.3052L75.35 33.2M75.35 33.2L77.1074 34.3815"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M79.0613 32.3052V34.1186C79.0613 34.229 79.1508 34.3186 79.2613 34.3186H81.7376C81.848 34.3186 81.9376 34.229 81.9376 34.1186V32.3052"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
          <path
            d="M86.6543 32.3052H84.2438C84.0005 32.3052 83.8033 32.5024 83.8033 32.7456V32.8557C83.8033 33.099 84.0005 33.2961 84.2438 33.2961H86.2768C86.5026 33.2961 86.6857 33.4792 86.6857 33.7051V33.9048C86.6857 34.1325 86.4997 34.3164 86.272 34.3138L83.8977 34.2871"
            stroke="#5E5E60"
            stroke-width="0.5"
            stroke-linecap="round"
          />
        </g>
        <animateTransform
          xlinkHref="#truck-logo"
          attributeName="transform"
          type="scale"
          from="1 0.88"
          to="1 1"
          dur="0.7s"
          repeatCount="indefinite"
        />
      </g>
    </svg>
    // <svg
    //   id="truck_svg"
    //   width={width}
    //   viewBox="0 0 137 75"
    //   // fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g clipPath="url(#clip0)">
    //     <g id="smoke">
    //       <path
    //         d="M23.1554 59.9661C26.8144 58.0246 27.8396 52.7925 25.4451 48.2797C23.0507 43.767 18.1435 41.6825 14.4845 43.6239C10.8255 45.5654 9.80036 50.7975 12.1948 55.3103C14.5892 59.823 19.4965 61.9075 23.1554 59.9661Z"
    //         fill="#AAAAAA"
    //       />
    //       <path
    //         d="M11.1511 55.8676C14.4735 54.1048 15.402 49.3496 13.225 45.2467C11.048 41.1438 6.58994 39.2467 3.26758 41.0095C-0.0547743 42.7723 -0.983287 47.5275 1.19369 51.6304C3.37068 55.7333 7.82877 57.6304 11.1511 55.8676Z"
    //         fill="#AAAAAA"
    //       />
    //       <path
    //         d="M15.874 60.7147C18.084 59.5421 18.7025 56.3807 17.2555 53.6535C15.8085 50.9264 12.8439 49.6662 10.6339 50.8388C8.42386 52.0114 7.80531 55.1728 9.25232 57.9C10.6993 60.6271 13.6639 61.8873 15.874 60.7147Z"
    //         fill="#AAAAAA"
    //       />
    //       <path
    //         d="M32.64 64.23L31.44 61.96C31.44 61.96 28.34 61.74 27.02 60.12C25.7 58.5 26.72 53.12 26.72 53.12L14.66 58.44C16.978 61.0695 19.9425 63.0481 23.26 64.18C26.3 65.09 31.99 64.77 32.64 64.23Z"
    //         fill="#AAAAAA"
    //       />
    //       <path
    //         d="M11.8916 47.8963C14.5846 46.4674 15.3387 42.6158 13.5758 39.2934C11.813 35.9711 8.20087 34.4361 5.50786 35.865C2.81485 37.2939 2.06077 41.1455 3.82358 44.4679C5.58639 47.7903 9.19855 49.3252 11.8916 47.8963Z"
    //         fill="#AAAAAA"
    //       />
    //     </g>
    //     <animate
    //       xlinkHref="#smoke"
    //       attributeName="opacity"
    //       values="0;1;0;"
    //       dur="1.2s"
    //       repeatCount="indefinite"
    //     />
    //     <g id="truck-body">
    //       <path d="M34.58 61.65H30.41V64.76H34.58V61.65Z" fill="#E0E0E0" />
    //       <path
    //         d="M124.91 28.63C121 18.46 114.73 18.46 114.73 18.46H99.92V46.25H130.4C128.996 40.2523 127.161 34.3637 124.91 28.63V28.63Z"
    //         fill="white"
    //       />
    //       <path d="M99.92 0H32.79V61.98H99.92V0Z" fill="#364E54" />
    //       <path
    //         d="M124.91 28.63C121 18.46 114.73 18.46 114.73 18.46H99.92V46.25H130.4C128.996 40.2523 127.161 34.3637 124.91 28.63V28.63ZM104.71 40.63V24.05H115.19C114.83 24.05 117.53 25.05 119.87 31.14C121.22 34.63 122.33 37.87 123.25 40.69L104.71 40.63Z"
    //         fill="#F4A147"
    //       />
    //       <path
    //         d="M136.67 54.58C136.67 58.67 133.87 61.98 130.4 61.98H106.19C102.72 61.98 99.92 58.67 99.92 54.58V48.1C99.92 44.01 102.72 40.7 106.19 40.7H130.4C133.87 40.7 136.67 44.01 136.67 48.1V54.58Z"
    //         fill="#F4A147"
    //       />
    //       <path d="M136.66 53.65H32.79V64.75H136.66V53.65Z" fill="#E0E0E0" />
    //       <path d="M136.66 56.88H32.79V59.53H136.66V56.88Z" fill="white" />
    //       <path d="M136.66 60.96H32.79V61.64H136.66V60.96Z" fill="white" />
    //       <g style={{ mixBlendMode: 'multiply' }}>
    //         <g style={{ mixBlendMode: 'multiply' }}>
    //           <path
    //             d="M69.77 0H32.79V53.65V61.98V64.76H69.77V0Z"
    //             fill="#E3D8DB"
    //           />
    //         </g>
    //       </g>
    //       <g style={{ mixBlendMode: 'multiply' }}>
    //         <g style={{ mixBlendMode: 'multiply' }}>
    //           <path
    //             d="M104.71 24.05L123.25 40.7H104.71V24.05Z"
    //             fill="#E3D8DB"
    //           />
    //         </g>
    //       </g>
    //       <path
    //         d="M131.2 40.77L130.39 40.7C130.39 40.7 129 46.85 136.66 50.46V48.1C136.67 44.33 134.29 41.23 131.2 40.77Z"
    //         fill="#FA753A"
    //       />
    //       <g style={{ mixBlendMode: 'multiply' }}>
    //         <g style={{ mixBlendMode: 'multiply' }}>
    //           <path
    //             d="M136.67 50.35H99.92V53.76H136.67V50.35Z"
    //             fill="#E3D8DB"
    //           />
    //         </g>
    //       </g>
    //     </g>
    //     <animateTransform
    //       xlinkHref="#truck-body"
    //       attributeName="transform"
    //       type="scale"
    //       from="1 0.88"
    //       to="1 1"
    //       dur="0.7s"
    //       repeatCount="indefinite"
    //     />
    //     <g id="left-wheel">
    //       <path
    //         d="M62.69 64.75C62.6155 66.6351 61.9883 68.4567 60.8865 69.9881C59.7848 71.5196 58.257 72.6932 56.4934 73.3631C54.7297 74.033 52.808 74.1695 50.9674 73.7557C49.1268 73.3419 47.4484 72.396 46.1412 71.0358C44.834 69.6755 43.9556 67.9609 43.6153 66.1052C43.275 64.2496 43.4878 62.3349 44.2273 60.5993C44.9668 58.8636 46.2003 57.3838 47.7743 56.3438C49.3483 55.3037 51.1934 54.7495 53.08 54.75C54.3679 54.7747 55.6383 55.0531 56.8185 55.5691C57.9987 56.0852 59.0656 56.8289 59.9581 57.7577C60.8507 58.6865 61.5514 59.7821 62.0201 60.9819C62.4889 62.1817 62.7165 63.4622 62.69 64.75Z"
    //         fill="#232323"
    //       />
    //       <path
    //         d="M53.08 71.05C56.4268 71.05 59.14 68.2339 59.14 64.76C59.14 61.2861 56.4268 58.47 53.08 58.47C49.7331 58.47 47.02 61.2861 47.02 64.76C47.02 68.2339 49.7331 71.05 53.08 71.05Z"
    //         fill="#F06B30"
    //       />
    //       <path
    //         d="M56.11 68.79C56.6678 68.79 57.12 68.3378 57.12 67.78C57.12 67.2222 56.6678 66.77 56.11 66.77C55.5522 66.77 55.1 67.2222 55.1 67.78C55.1 68.3378 55.5522 68.79 56.11 68.79Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M50.11 68.79C50.6678 68.79 51.12 68.3378 51.12 67.78C51.12 67.2222 50.6678 66.77 50.11 66.77C49.5522 66.77 49.1 67.2222 49.1 67.78C49.1 68.3378 49.5522 68.79 50.11 68.79Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M50.11 62.79C50.6678 62.79 51.12 62.3378 51.12 61.78C51.12 61.2222 50.6678 60.77 50.11 60.77C49.5522 60.77 49.1 61.2222 49.1 61.78C49.1 62.3378 49.5522 62.79 50.11 62.79Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M56.11 62.79C56.6678 62.79 57.12 62.3378 57.12 61.78C57.12 61.2222 56.6678 60.77 56.11 60.77C55.5522 60.77 55.1 61.2222 55.1 61.78C55.1 62.3378 55.5522 62.79 56.11 62.79Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M53.11 65.79C53.6678 65.79 54.12 65.3378 54.12 64.78C54.12 64.2222 53.6678 63.77 53.11 63.77C52.5522 63.77 52.1 64.2222 52.1 64.78C52.1 65.3378 52.5522 65.79 53.11 65.79Z"
    //         fill="#E0E0E0"
    //       />
    //     </g>
    //     <g id="right-wheel">
    //       <path
    //         d="M125.99 64.75C125.915 66.6351 125.288 68.4567 124.187 69.9881C123.085 71.5196 121.557 72.6932 119.793 73.3631C118.03 74.033 116.108 74.1695 114.267 73.7557C112.427 73.3419 110.748 72.396 109.441 71.0358C108.134 69.6755 107.256 67.9609 106.915 66.1052C106.575 64.2496 106.788 62.3349 107.527 60.5993C108.267 58.8636 109.5 57.3838 111.074 56.3438C112.648 55.3037 114.493 54.7495 116.38 54.75C117.668 54.7734 118.939 55.0509 120.12 55.5665C121.301 56.0821 122.368 56.8258 123.261 57.7548C124.154 58.6839 124.855 59.78 125.323 60.9804C125.791 62.1808 126.018 63.4618 125.99 64.75V64.75Z"
    //         fill="#232323"
    //       />
    //       <path
    //         d="M116.37 71.05C119.711 71.05 122.42 68.2339 122.42 64.76C122.42 61.2861 119.711 58.47 116.37 58.47C113.029 58.47 110.32 61.2861 110.32 64.76C110.32 68.2339 113.029 71.05 116.37 71.05Z"
    //         fill="#F06B30"
    //       />
    //       <path
    //         d="M119.37 68.77C119.928 68.77 120.38 68.3178 120.38 67.76C120.38 67.2022 119.928 66.75 119.37 66.75C118.812 66.75 118.36 67.2022 118.36 67.76C118.36 68.3178 118.812 68.77 119.37 68.77Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M113.37 68.77C113.928 68.77 114.38 68.3178 114.38 67.76C114.38 67.2022 113.928 66.75 113.37 66.75C112.812 66.75 112.36 67.2022 112.36 67.76C112.36 68.3178 112.812 68.77 113.37 68.77Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M113.37 62.77C113.928 62.77 114.38 62.3178 114.38 61.76C114.38 61.2022 113.928 60.75 113.37 60.75C112.812 60.75 112.36 61.2022 112.36 61.76C112.36 62.3178 112.812 62.77 113.37 62.77Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M119.37 62.77C119.928 62.77 120.38 62.3178 120.38 61.76C120.38 61.2022 119.928 60.75 119.37 60.75C118.812 60.75 118.36 61.2022 118.36 61.76C118.36 62.3178 118.812 62.77 119.37 62.77Z"
    //         fill="#E0E0E0"
    //       />
    //       <path
    //         d="M116.37 65.77C116.928 65.77 117.38 65.3178 117.38 64.76C117.38 64.2022 116.928 63.75 116.37 63.75C115.812 63.75 115.36 64.2022 115.36 64.76C115.36 65.3178 115.812 65.77 116.37 65.77Z"
    //         fill="#E0E0E0"
    //       />
    //     </g>
    //     <rect x="44" y="12" width="41" height="29" fill="url(#pattern0)" />
    //     <g id="truck-logo">
    //       <path
    //         d="M45 21.92H70.75C70.75 21.92 73.28 22.55 73 24.61C72.72 26.67 70.35 38 70.35 38C70.35 38 75.01 37.38 77.26 34H80.92C80.92 34 78.55 38.5 74.64 40C71.9903 41.2509 68.999 41.5817 66.14 40.94L69.27 25.22L47.83 25.23C47.4082 25.2574 46.9858 25.186 46.5964 25.0217C46.207 24.8574 45.8613 24.6045 45.5866 24.2833C45.3119 23.962 45.1159 23.5812 45.0141 23.171C44.9122 22.7607 44.9074 22.3324 45 21.92V21.92Z"
    //         fill="#02717E"
    //       />
    //       <path
    //         d="M47.69 26H68.4L67.81 29.36H50.41C49.9888 29.3824 49.5683 29.3047 49.183 29.1332C48.7977 28.9618 48.4584 28.7015 48.193 28.3737C47.9277 28.0459 47.7437 27.6599 47.6563 27.2473C47.5689 26.8347 47.5804 26.4073 47.69 26V26Z"
    //         fill="#02717E"
    //       />
    //       <path
    //         d="M51.11 30H67.63L67 33.34H53.55C53.55 33.34 50.77 33.39 51.11 30Z"
    //         fill="#02717E"
    //       />
    //       <path
    //         d="M56.9 34H60.73C62.0214 35.7553 63.8565 37.0349 65.95 37.64L65.37 40.73C65.37 40.73 60.55 40.25 56.9 34Z"
    //         fill="#F27023"
    //       />
    //       <path
    //         d="M57.08 21.17H60.75C60.75 21.17 64.5 15.8 72.08 17.63C72.08 17.63 76.71 19.21 78.37 23.17C78.37 23.17 81.2 27.51 77.79 33.34H81.29C81.29 33.34 84.04 28.88 81.62 22.46C80.597 20.124 78.9646 18.1061 76.8938 16.6177C74.8231 15.1293 72.3902 14.2252 69.85 14C67.2545 13.822 64.6635 14.4056 62.395 15.6793C60.1265 16.953 58.2793 18.8613 57.08 21.17V21.17Z"
    //         fill="#F27023"
    //       />
    //     </g>
    //     <animateTransform
    //       xlinkHref="#truck-logo"
    //       attributeName="transform"
    //       type="scale"
    //       from="1 0.88"
    //       to="1 1"
    //       dur="0.7s"
    //       repeatCount="indefinite"
    //     />
    //   </g>
    // </svg>
  );
};

const LoaderIcon = props => {
  const { width = 60 } = props;
  return (
    <svg width={width} viewBox="0 0 100 100" y="0" x="0">
      <g className="ldl-scale" style={{ transformOrigin: '50% 50%' }}>
        <g className="ldl-ani" style={{ transformOrigin: '50px 50px' }}>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.29556s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#f5e6c8"
                d="M15 64.3h40.5c3.1 0 5.6-2.5 5.6-5.6V31c0-3.1-2.5-5.6-5.6-5.6H15c-3.1 0-5.6 2.5-5.6 5.6v27.7c0 3.1 2.5 5.6 5.6 5.6z"
                style={{ fill: 'rgb(26, 55, 62)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.29778s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#66503a"
                d="M51.5 58.5c-.5 0-1-.4-1-1V24.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v32.9c0 .6-.4 1-1 1z"
                style={{ fill: 'rgb(18, 41, 43)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.3s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#66503a"
                d="M40.6 58.5c-.5 0-1-.4-1-1V24.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v32.9c0 .6-.4 1-1 1z"
                style={{ fill: 'rgb(18, 41, 43)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.30222s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#66503a"
                d="M29.7 58.5c-.5 0-1-.4-1-1V24.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v32.9c0 .6-.4 1-1 1z"
                style={{ fill: 'rgb(18, 41, 43)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.30444s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#66503a"
                d="M18.8 58.5c-.5 0-1-.4-1-1V24.6c0-.5.4-1 1-1 .5 0 1 .4 1 1v32.9c0 .6-.4 1-1 1z"
                style={{ fill: 'rgb(18, 41, 43)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.30667s infinite normal forwards running bounce',
              }}
            >
              <path
                d="M7.9 57.1h56.7v8H7.9z"
                fill="#4d85ab"
                style={{ fill: 'rgb(245, 245, 245)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.30889s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#e15b64"
                d="M11.9 59.2h-4c-.2 0-.4.2-.4.4V63c0 .2.2.4.4.4H12c1 0 1.8-.8 1.8-1.8v-.5c0-1-.9-1.9-1.9-1.9z"
                style={{ fill: 'rgb(255, 193, 102)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.31111s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#77a4bd"
                d="M88.9 69.5H66.8c-1.6 0-2.8-1.3-2.8-2.8l.1-31c0-1.6 1.3-2.8 2.8-2.8h13c1 0 2 .6 2.5 1.5l8.9 16.2c.2.4.3.9.3 1.4v14.8c.1 1.5-1.2 2.7-2.7 2.7z"
                style={{ fill: 'rgb(255, 165, 84)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.31333s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#666"
                d="M73.5 65.1H9.7s-.3 0-.3.4c0 2.4 1.3 4 3.3 4h60.8c1 0 1.7-1 1.7-2.2 0-1.2-.8-2.2-1.7-2.2z"
                style={{ fill: 'rgb(241, 242, 243)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g className="ldl-ani" style={{ transformOrigin: '50px 50px' }}>
              <g>
                <g className="ldl-layer">
                  <g
                    className="ldl-ani"
                    style={{
                      transformOrigin: '50px 50px',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      animation:
                        '1.33333s linear -1.31556s infinite normal forwards running bounce',
                    }}
                  >
                    <circle
                      fill="#fff"
                      r="7.4"
                      cy="67.4"
                      cx="25.6"
                      style={{ fill: 'rgb(245, 245, 245)' }}
                    ></circle>
                  </g>
                </g>
                <g className="ldl-layer">
                  <g
                    className="ldl-ani"
                    style={{
                      transformOrigin: '50px 50px',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      animation:
                        '1.33333s linear -1.31778s infinite normal forwards running bounce',
                    }}
                  >
                    <path
                      fill="#333"
                      d="M25.6 61.5c3.3 0 5.9 2.7 5.9 5.9s-2.7 5.9-5.9 5.9-5.9-2.7-5.9-5.9 2.7-5.9 5.9-5.9m0-3c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-3.9-8.9-8.9-8.9z"
                      style={{ fill: 'rgb(26, 55, 62)' }}
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g className="ldl-layer">
            <g className="ldl-ani" style={{ transformOrigin: '50px 50px' }}>
              <g>
                <g className="ldl-layer">
                  <g
                    className="ldl-ani"
                    style={{
                      transformOrigin: '50px 50px',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      animation:
                        '1.33333s linear -1.32s infinite normal forwards running bounce',
                    }}
                  >
                    <circle
                      fill="#e6e6e6"
                      r="4"
                      cy="67.4"
                      cx="25.6"
                      style={{ fill: 'rgb(241, 242, 243)' }}
                    ></circle>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g className="ldl-layer">
            <g className="ldl-ani" style={{ transformOrigin: '50px 50px' }}>
              <g>
                <g className="ldl-layer">
                  <g
                    className="ldl-ani"
                    style={{
                      transformOrigin: '50px 50px',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      animation:
                        '1.33333s linear -1.32222s infinite normal forwards running bounce',
                    }}
                  >
                    <circle
                      fill="#fff"
                      r="7.4"
                      cy="67.4"
                      cx="72.9"
                      style={{ fill: 'rgb(245, 245, 245)' }}
                    ></circle>
                  </g>
                </g>
                <g className="ldl-layer">
                  <g
                    className="ldl-ani"
                    style={{
                      transformOrigin: '50px 50px',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      animation:
                        '1.33333s linear -1.32444s infinite normal forwards running bounce',
                    }}
                  >
                    <path
                      fill="#333"
                      d="M72.9 61.5c3.3 0 5.9 2.7 5.9 5.9s-2.7 5.9-5.9 5.9-5.9-2.6-5.9-5.9 2.6-5.9 5.9-5.9m0-3c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
                      style={{ fill: 'rgb(26, 55, 62)' }}
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g className="ldl-layer">
            <g className="ldl-ani" style={{ transformOrigin: '50px 50px' }}>
              <g>
                <g className="ldl-layer">
                  <g
                    className="ldl-ani"
                    style={{
                      transformOrigin: '50px 50px',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                      animation:
                        '1.33333s linear -1.32667s infinite normal forwards running bounce',
                    }}
                  >
                    <circle
                      fill="#e6e6e6"
                      r="4"
                      cy="67.4"
                      cx="72.9"
                      style={{ fill: 'rgb(241, 242, 243)' }}
                    ></circle>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.32889s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#e0e0e0"
                d="M86.9 60.1h4.4c.6 0 1.1-.5 1.1-1.1v-1.9c0-.6-.5-1.1-1.1-1.1H87c-.3 0-.5.2-.5.5v3.2c0 .2.2.4.4.4z"
                style={{ fill: 'rgb(18, 41, 43)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.33111s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#333"
                d="M80.8 36.6c-.4-.7-1.1-1.2-2-1.2H68.5c-1.2 0-2.2 1-2.2 2.3l-.1 13.5h22.7c0-.2-.1-.4-.2-.6l-7.9-14z"
                style={{ fill: 'rgb(26, 55, 62)' }}
              ></path>
            </g>
          </g>
          <g className="ldl-layer">
            <g
              className="ldl-ani"
              style={{
                transformOrigin: '50px 50px',
                transform: 'matrix(1, 0, 0, 1, 0, 0)',
                animation:
                  '1.33333s linear -1.33333s infinite normal forwards running bounce',
              }}
            >
              <path
                fill="#4d85ab"
                d="M71.8 55.5h-3.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h3.5c.5 0 .9.4.9.9s-.4.9-.9.9z"
                style={{ fill: 'rgb(245, 245, 245)' }}
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const DownloadIcon = props => {
  const { width } = props;
  return (
    <svg
      width={width}
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.51562 9.34375H6.29688V10.5625H7.51562V9.34375ZM5.48438 7.3125H4.26562V8.53125H5.48438V7.3125ZM7.51562 7.3125H6.29688V8.53125H7.51562V7.3125ZM5.48438 9.34375H4.26562V10.5625H5.48438V9.34375ZM5.6875 3.45312V0H0.609375C0.27168 0 0 0.27168 0 0.609375V12.3906C0 12.7283 0.27168 13 0.609375 13H9.14062C9.47832 13 9.75 12.7283 9.75 12.3906V4.0625H6.29688C5.96172 4.0625 5.6875 3.78828 5.6875 3.45312ZM8.32812 6.09375V10.9688C8.32812 11.1932 8.14633 11.375 7.92188 11.375H1.82812C1.60367 11.375 1.42188 11.1932 1.42188 10.9688V6.09375C1.42188 5.8693 1.60367 5.6875 1.82812 5.6875H7.92188C8.14633 5.6875 8.32812 5.8693 8.32812 6.09375ZM9.57227 2.66602L7.08652 0.177734C6.97227 0.0634766 6.81738 0 6.65488 0H6.5V3.25H9.75V3.09512C9.75 2.93516 9.68652 2.78027 9.57227 2.66602ZM3.45312 7.3125H2.23438V8.53125H3.45312V7.3125ZM3.45312 9.34375H2.23438V10.5625H3.45312V9.34375Z"
        fill="#64696D"
      />
    </svg>
  );
};

const ExportIcon = props => {
  const { width } = props;
  return (
    <svg
      width={width}
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.7088 3.45312V0H0.611657C0.272697 0 0 0.27168 0 0.609375V12.3906C0 12.7283 0.272697 13 0.611657 13H9.17486C9.51382 13 9.78652 12.7283 9.78652 12.3906V4.0625H6.32046C5.98405 4.0625 5.7088 3.78828 5.7088 3.45312ZM7.65719 8.81969L5.19985 11.2496C5.03037 11.4174 4.75666 11.4174 4.58718 11.2496L2.12984 8.81969C1.87116 8.564 2.05262 8.125 2.41656 8.125H4.07772V6.09375C4.07772 5.8693 4.26019 5.6875 4.48549 5.6875H5.30103C5.52632 5.6875 5.7088 5.8693 5.7088 6.09375V8.125H7.36996C7.7339 8.125 7.91536 8.564 7.65719 8.81969ZM9.60812 2.66602L7.11307 0.177734C6.99838 0.0634766 6.84292 0 6.67981 0H6.52434V3.25H9.78652V3.09512C9.78652 2.93516 9.7228 2.78027 9.60812 2.66602Z"
        fill="#64696D"
      />
    </svg>
  );
};
const LoginIcon = props => {
  const { width } = props;
  return (
    <svg
      width={width}
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74468 5.80951L7.72992 5.82427L2.30799 0.402344L0.131714 2.57923L5.55303 8.00054L0.131714 13.4231L2.30799 15.5994L7.7293 10.1762L7.74468 10.1922L9.92095 8.0153L9.90619 8.00054L9.92095 7.98578L7.74468 5.80951Z"
        fill="#257B92"
      />
    </svg>
  );
};
const LoadingIcon = props => {
  const { width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="2" r="2" fill="#257B92" />
      <circle cx="14" cy="2" r="2" fill="#257B92" />
      <circle cx="2" cy="2" r="2" fill="#257B92" />
    </svg>
  );
};

function CaretDown(props) {
  const { width } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width={width}>
      <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" />
    </svg>
  );
}

function ExpandIcon(props) {
  const { width, isexpanded } = props;

  return isexpanded ? (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 16 10">
      <title>Collapse</title>
      <path d="M14.59 9.58984L16 8.16984L12.83 4.99984L16 1.82984L14.59 0.419844L10 4.99984L14.59 9.58984ZM1.41 0.409843L0 1.82984L3.17 4.99984L0 8.16984L1.41 9.58984L6 4.99984L1.41 0.409843Z" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 18 10">
      <title>Expand</title>
      <path d="M2.83 4.99984L6 1.82984L4.59 0.419844L0 4.99984L4.59 9.58984L6 8.16984L2.83 4.99984ZM15.17 4.99984L12 8.16984L13.41 9.57984L18 4.99984L13.41 0.409843L12 1.82984L15.17 4.99984Z" />
    </svg>
  );
}

function BackIcon(props) {
  const { width = '24', ...rest } = props;

  return (
    <svg
      width={width}
      viewBox="0 0 10 9"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.74824 8.39718L5.25276 8.8547C5.04296 9.04843 4.70372 9.04843 4.49615 8.8547L0.157349 4.85035C-0.0524495 4.65663 -0.0524495 4.34337 0.157349 4.15171L4.49615 0.145294C4.70595 -0.0484314 5.0452 -0.0484314 5.25276 0.145294L5.74824 0.602817C5.96027 0.798603 5.95581 1.11804 5.73932 1.30971L3.04988 3.67564H9.46435C9.76119 3.67564 10 3.89615 10 4.17025V4.82975C10 5.10385 9.76119 5.32436 9.46435 5.32436H3.04988L5.73932 7.69029C5.95804 7.88196 5.9625 8.2014 5.74824 8.39718Z"
        fill="#64696D"
      />
    </svg>
  );
}

function AccountManagementIcon(props) {
  const { width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      viewBox="0 0 24 18"
      fill="none"
    >
      <path
        d="M10.7775 8.40405C10.8863 8.0138 11.0212 7.63855 11.1862 7.27831C9.92625 6.92183 8.99625 5.77358 8.99625 4.40018C8.99625 2.74534 10.3425 1.39821 11.9963 1.39821C13.3688 1.39821 14.5125 2.32882 14.8725 3.58964C15.2325 3.42454 15.6075 3.28569 15.9975 3.18063C15.4725 1.462 13.89 0.201172 12 0.201172C9.67875 0.201172 7.8 2.08115 7.8 4.40393C7.8 6.29517 9.06 7.87871 10.7775 8.40405ZM3.6 7.4059C5.2575 7.4059 6.6 6.06252 6.6 4.40393C6.6 2.74534 5.2575 1.40196 3.6 1.40196C1.9425 1.40196 0.6 2.74534 0.6 4.40393C0.6 6.06252 1.9425 7.4059 3.6 7.4059ZM3.6 2.60275C4.59375 2.60275 5.4 3.40953 5.4 4.40393C5.4 5.39833 4.59375 6.20511 3.6 6.20511C2.60625 6.20511 1.8 5.39833 1.8 4.40393C1.8 3.40953 2.60625 2.60275 3.6 2.60275ZM5.89125 9.09075C5.445 8.7868 4.91625 8.60668 4.35 8.60668H2.85C1.27875 8.60668 0 9.95382 0 11.6087C0 11.9389 0.27 12.209 0.6 12.209C0.93 12.209 1.2 11.9389 1.2 11.6087C1.2 10.6143 1.9425 9.80747 2.85 9.80747H4.35C4.55625 9.80747 4.755 9.8525 4.93875 9.9313C5.22 9.61234 5.5425 9.33091 5.89125 9.09075ZM6.6 15.8114C6.27 15.8114 6 15.5412 6 15.211V13.5299C6 12.907 6.18375 12.3029 6.52875 11.7888C7.04625 11.0195 7.96875 10.558 8.9925 10.558C9.52875 10.558 9.6975 10.648 10.5188 10.8281C10.5113 10.6855 10.4663 10.3253 10.5413 9.60484C9.93 9.44348 9.55125 9.35718 8.9925 9.35718C7.63125 9.35718 6.3075 9.96508 5.53125 11.1171C5.06625 11.8075 4.79625 12.6368 4.79625 13.5299V15.211C4.79625 16.2054 5.6025 17.0122 6.59625 17.0122H14.4338C13.8338 16.6895 13.2863 16.2805 12.8025 15.8114H6.6ZM18 7.98753C16.665 7.98753 15.5813 9.07574 15.5813 10.4079C15.5813 11.74 16.665 12.8282 18 12.8282C19.335 12.8282 20.4188 11.74 20.4188 10.4079C20.4188 9.07574 19.335 7.98753 18 7.98753ZM18 11.6274C17.3288 11.6274 16.7812 11.0796 16.7812 10.4079C16.7812 9.73618 17.3288 9.18832 18 9.18832C18.6713 9.18832 19.2188 9.73618 19.2188 10.4079C19.2188 11.0796 18.6713 11.6274 18 11.6274ZM23.5613 11.2447L22.9425 10.8882C22.9725 10.5692 22.9725 10.2465 22.9425 9.92755L23.565 9.57107C23.9213 9.36468 24.0825 8.94441 23.9588 8.5579C23.6888 7.67983 23.2125 6.85429 22.5825 6.17509C22.305 5.87114 21.8588 5.8036 21.5025 6.00998L20.8838 6.36647C20.6213 6.17884 20.3438 6.01749 20.0513 5.88615V5.17318C20.0513 4.76041 19.77 4.41143 19.3688 4.32137C18.4725 4.11874 17.52 4.11874 16.62 4.32137C16.2188 4.41143 15.9375 4.76416 15.9375 5.17318V5.88615C15.645 6.01749 15.3638 6.17884 15.105 6.36647L14.4862 6.00998C14.13 5.8036 13.6875 5.87114 13.41 6.17509C12.78 6.85429 12.3075 7.67983 12.0338 8.55415C11.91 8.94441 12.0788 9.37219 12.4313 9.57482L13.05 9.9313C13.02 10.2503 13.02 10.573 13.05 10.8919L12.4275 11.2484C12.0788 11.451 11.91 11.8826 12.0338 12.2653C12.3075 13.1434 12.78 13.969 13.41 14.6481C13.6875 14.9483 14.13 15.0159 14.49 14.8133L15.1088 14.4568C15.3713 14.6444 15.6488 14.8058 15.9413 14.9371V15.6501C15.9413 16.0628 16.2225 16.4118 16.6238 16.5019C17.0737 16.6032 17.535 16.652 17.9963 16.652C18.4575 16.652 18.9225 16.6032 19.3688 16.5019C19.77 16.4118 20.0513 16.0591 20.0513 15.6501V14.9371C20.3438 14.8058 20.6213 14.6444 20.8838 14.4568L21.5025 14.8133C21.855 15.0159 22.3013 14.9483 22.5788 14.6481C23.2087 13.969 23.6812 13.1434 23.955 12.2691C24.0825 11.8788 23.9137 11.4473 23.5613 11.2447ZM21.6263 11.5148L22.7288 12.1528C22.53 12.6894 22.2413 13.1959 21.8738 13.635L20.7713 12.9971C19.9688 13.6838 19.8525 13.7513 18.855 14.104V15.3799C18.2887 15.4774 17.7075 15.4774 17.145 15.3799V14.104C16.1363 13.7476 16.0125 13.665 15.2288 12.9971L14.1263 13.635C13.7588 13.1922 13.4663 12.6894 13.2713 12.1528L14.3737 11.5148C14.19 10.5092 14.1788 10.3666 14.3737 9.30089L13.2713 8.66297C13.4663 8.12637 13.7588 7.62354 14.1263 7.18075L15.2288 7.81867C16.0312 7.13197 16.1475 7.06442 17.145 6.71169V5.43585C17.7113 5.34204 18.2962 5.34204 18.855 5.43585V6.71169C19.86 7.06818 19.9875 7.14698 20.7713 7.81867L21.8738 7.18075C22.2413 7.62354 22.5338 8.12637 22.7288 8.66297L21.6263 9.30089C21.81 10.3065 21.8213 10.4491 21.6263 11.5148Z"
        fill="white"
      />
    </svg>
  );
}

function SettingsIcon(props) {
  const { width } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 24 19">
      <path d="M20.1974 7.36486L20.1036 7.21861C19.9499 7.22986 19.7999 7.22986 19.6461 7.21861L19.5524 7.36861C19.3349 7.71361 18.9111 7.87111 18.5211 7.74736C18.0036 7.58611 17.6586 7.41736 17.2349 7.06861C16.8974 6.79111 16.8149 6.30736 17.0324 5.92861L17.1261 5.76736C17.0399 5.63986 16.9649 5.50861 16.8974 5.36986H16.5561C16.1211 5.36986 15.7536 5.06236 15.6711 4.63486C15.5736 4.12111 15.5699 3.72736 15.6749 3.19111C15.7536 2.76736 16.1286 2.45986 16.5599 2.45986H16.8974C16.9649 2.32111 17.0399 2.18986 17.1261 2.06236L17.0286 1.89361C16.8111 1.51861 16.8936 1.04236 17.2236 0.757359C17.6211 0.416109 17.9624 0.221109 18.4799 0.0448591C18.8849 -0.0938909 19.3311 0.0711091 19.5486 0.442359L19.6461 0.607359C19.7999 0.596109 19.9499 0.596109 20.1036 0.607359L20.2011 0.442359C20.4186 0.0711091 20.8649 -0.0938909 21.2736 0.0486091C21.7724 0.217359 22.1099 0.408609 22.5299 0.764859C22.8599 1.04611 22.9386 1.52236 22.7211 1.89736L22.6236 2.06236C22.7099 2.18986 22.7849 2.32111 22.8524 2.45986H23.0436C23.4786 2.45986 23.8461 2.76736 23.9286 3.19486C24.0261 3.70861 24.0299 4.10236 23.9249 4.63861C23.8461 5.06236 23.4711 5.36986 23.0399 5.36986H22.8524C22.7849 5.50861 22.7099 5.63986 22.6236 5.76736L22.7174 5.92861C22.9386 6.31111 22.8486 6.79486 22.5111 7.07236C22.1099 7.40236 21.7649 7.57486 21.2361 7.74361C20.8424 7.86736 20.4149 7.71361 20.1974 7.36486ZM20.6549 6.07111L21.0524 6.75736C21.3036 6.65236 21.5361 6.51736 21.7536 6.35236L21.3561 5.66611L21.5961 5.38486C21.7761 5.17111 21.9186 4.93111 22.0086 4.66861L22.1324 4.31986H22.9236C22.9574 4.05361 22.9574 3.77986 22.9236 3.51361H22.1324L22.0086 3.16486C21.9149 2.90236 21.7761 2.66236 21.5961 2.44861L21.3561 2.16736L21.7499 1.47736C21.5361 1.31236 21.2999 1.17736 21.0486 1.07236L20.6511 1.75861L20.2874 1.69111C20.0136 1.63861 19.7324 1.63861 19.4586 1.69111L19.0949 1.75861L18.6974 1.07236C18.4499 1.17361 18.2136 1.31236 17.9999 1.47736L18.3974 2.16361L18.1574 2.44486C17.9774 2.65861 17.8349 2.89861 17.7449 3.16111L17.6211 3.50986H16.8299C16.7961 3.77611 16.7961 4.04986 16.8299 4.31611H17.6211L17.7449 4.66486C17.8386 4.92736 17.9774 5.16736 18.1574 5.38111L18.3974 5.66236L17.9999 6.35236C18.2136 6.51736 18.4499 6.65236 18.7011 6.75736L19.0986 6.07111L19.4624 6.13861C19.7361 6.19111 20.0174 6.19111 20.2911 6.13861L20.6549 6.07111ZM5.44863 17.0399V15.8549C4.96488 15.6486 4.50738 15.3824 4.08363 15.0636L3.05238 15.6599C2.68488 15.8699 2.22363 15.7986 1.93863 15.4874C1.03113 14.5011 0.494876 13.6311 0.0411255 12.1836C-0.0863745 11.7824 0.0823755 11.3474 0.446126 11.1336L1.46988 10.5374C1.40613 10.0124 1.40613 9.48361 1.46988 8.95861L0.446126 8.36611C0.0823755 8.15611 -0.0863745 7.71736 0.0411255 7.31611C0.494876 5.87611 1.02363 5.00611 1.93863 4.01236C2.22363 3.70111 2.68863 3.62986 3.05238 3.83986L4.07988 4.43611C4.50363 4.11736 4.96113 3.85486 5.44488 3.64486V2.45986C5.44488 2.03611 5.73738 1.67236 6.14988 1.58236C7.45113 1.28986 8.47488 1.25611 9.96363 1.58236C10.3761 1.67236 10.6724 2.03986 10.6724 2.45986V3.64486C11.1561 3.85111 11.6136 4.11736 12.0374 4.43236L13.0649 3.83986C13.4324 3.62986 13.8974 3.70111 14.1824 4.01236C15.1911 5.12236 15.7386 6.10861 16.1361 7.33111C16.2636 7.72486 16.1061 8.15236 15.7536 8.36986L14.8161 8.96236C14.8799 9.48736 14.8799 10.0161 14.8161 10.5411L15.8699 11.1974C16.1924 11.3999 16.3574 11.7824 16.2749 12.1536C16.0161 13.3274 15.0374 14.5761 14.1786 15.4986C13.8936 15.8061 13.4324 15.8736 13.0686 15.6636L12.0374 15.0674C11.6136 15.3861 11.1561 15.6486 10.6724 15.8586V17.0436C10.6724 17.4636 10.3799 17.8311 9.96737 17.9211C8.56112 18.2324 7.53363 18.2286 6.14613 17.9211C5.74113 17.8274 5.44863 17.4599 5.44863 17.0399ZM6.64863 16.8074C7.57863 16.9949 8.54238 16.9949 9.47238 16.8074V15.0186L9.87362 14.8761C10.5036 14.6549 11.0849 14.3174 11.5949 13.8824L11.9174 13.6049L13.4699 14.5011C14.0999 13.7849 14.7449 12.9524 15.0486 12.0561L13.4961 11.1599L13.5749 10.7436C13.6949 10.0836 13.6949 9.41236 13.5749 8.75236L13.4961 8.33611L15.0486 7.43986C14.7449 6.54361 14.0999 5.70736 13.4699 4.99486L11.9174 5.89111L11.5949 5.61361C11.0849 5.17486 10.5074 4.84111 9.87362 4.61986L9.47238 4.47736V2.69236C8.54238 2.50486 7.57863 2.50486 6.64863 2.69236V4.48111L6.24738 4.62361C5.61738 4.84486 5.03613 5.18236 4.52613 5.61736L4.20363 5.89486L2.65113 4.99861C2.02323 5.71239 1.54276 6.54335 1.23738 7.44361L2.78988 8.33986L2.71113 8.75611C2.59113 9.41611 2.59113 10.0874 2.71113 10.7474L2.78988 11.1636L1.23738 12.0599C1.54113 12.9561 2.02113 13.7924 2.65113 14.5049L4.20363 13.6086L4.52613 13.8861C5.03613 14.3249 5.61363 14.6586 6.24738 14.8799L6.64863 15.0224V16.8074ZM8.08863 12.8586C6.37488 12.8586 4.97988 11.4636 4.97988 9.74986C4.97988 8.03611 6.37488 6.64111 8.08863 6.64111C9.80238 6.64111 11.1974 8.03611 11.1974 9.74986C11.1974 11.4636 9.80238 12.8586 8.08863 12.8586ZM8.08863 7.84111C7.03863 7.84111 6.17988 8.69611 6.17988 9.74986C6.17988 10.8036 7.03488 11.6586 8.08863 11.6586C9.13863 11.6586 9.99738 10.8036 9.99738 9.74986C9.99738 8.69611 9.14238 7.84111 8.08863 7.84111ZM20.1974 18.7799L20.1036 18.6336C19.9499 18.6449 19.7999 18.6449 19.6461 18.6336L19.5524 18.7836C19.3349 19.1286 18.9111 19.2861 18.5211 19.1624C18.0036 19.0011 17.6586 18.8324 17.2349 18.4836C16.8974 18.2061 16.8149 17.7224 17.0324 17.3436L17.1261 17.1824C17.0399 17.0549 16.9649 16.9236 16.8974 16.7849H16.5561C16.1211 16.7849 15.7536 16.4774 15.6711 16.0499C15.5736 15.5361 15.5699 15.1424 15.6749 14.6061C15.7536 14.1824 16.1286 13.8749 16.5599 13.8749H16.8974C16.9649 13.7361 17.0399 13.6049 17.1261 13.4774L17.0286 13.3086C16.8111 12.9336 16.8936 12.4574 17.2236 12.1724C17.6211 11.8311 17.9624 11.6361 18.4799 11.4599C18.8849 11.3211 19.3311 11.4861 19.5486 11.8574L19.6461 12.0224C19.7999 12.0111 19.9499 12.0111 20.1036 12.0224L20.2011 11.8574C20.4186 11.4861 20.8649 11.3211 21.2736 11.4636C21.7724 11.6324 22.1099 11.8236 22.5299 12.1799C22.8599 12.4611 22.9386 12.9374 22.7211 13.3124L22.6236 13.4774C22.7099 13.6049 22.7849 13.7361 22.8524 13.8749H23.0436C23.4786 13.8749 23.8461 14.1824 23.9286 14.6099C24.0261 15.1236 24.0299 15.5174 23.9249 16.0536C23.8461 16.4774 23.4711 16.7849 23.0399 16.7849H22.8524C22.7849 16.9236 22.7099 17.0549 22.6236 17.1824L22.7174 17.3436C22.9386 17.7261 22.8486 18.2099 22.5111 18.4874C22.1099 18.8174 21.7649 18.9899 21.2361 19.1586C20.8424 19.2786 20.4149 19.1249 20.1974 18.7799ZM20.6549 17.4824L21.0524 18.1686C21.3036 18.0636 21.5361 17.9286 21.7536 17.7636L21.3561 17.0774L21.5961 16.7961C21.7761 16.5824 21.9186 16.3424 22.0086 16.0799L22.1324 15.7311H22.9236C22.9574 15.4649 22.9574 15.1911 22.9236 14.9249H22.1324L22.0086 14.5761C21.9149 14.3136 21.7761 14.0736 21.5961 13.8599L21.3561 13.5786L21.7536 12.8924C21.5399 12.7274 21.3036 12.5924 21.0524 12.4874L20.6549 13.1736L20.2911 13.1061C20.0174 13.0536 19.7361 13.0536 19.4624 13.1061L19.0986 13.1736L18.7011 12.4874C18.4499 12.5924 18.2174 12.7274 17.9999 12.8924L18.3974 13.5786L18.1574 13.8599C17.9774 14.0736 17.8349 14.3136 17.7449 14.5761L17.6211 14.9249H16.8299C16.7961 15.1911 16.7961 15.4649 16.8299 15.7311H17.6211L17.7449 16.0799C17.8386 16.3424 17.9774 16.5824 18.1574 16.7961L18.3974 17.0774L17.9999 17.7636C18.2136 17.9286 18.4499 18.0636 18.7011 18.1686L19.0986 17.4824L19.4624 17.5499C19.7361 17.6024 20.0174 17.6024 20.2911 17.5499L20.6549 17.4824ZM20.9999 15.2999C20.9999 14.6361 20.4636 14.0999 19.7999 14.0999C19.1361 14.0999 18.5999 14.6361 18.5999 15.2999C18.5999 15.9636 19.1361 16.4999 19.7999 16.4999C20.4636 16.4999 20.9999 15.9636 20.9999 15.2999ZM20.9999 3.88861C20.9999 3.22486 20.4636 2.68861 19.7999 2.68861C19.1361 2.68861 18.5999 3.22486 18.5999 3.88861C18.5999 4.55236 19.1361 5.08861 19.7999 5.08861C20.4636 5.08861 20.9999 4.54861 20.9999 3.88861Z" />
    </svg>
  );
}
function NoStepsIcon(props) {
  const { width } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 199 199">
      <circle
        cx="156.5"
        cy="156.5"
        r="38.5"
        fill="white"
        stroke="#FF8E8E"
        stroke-width="8"
      />
      <line
        x1="41.5"
        y1="84"
        x2="41.5"
        y2="115"
        stroke="#B0B0B0"
        stroke-width="11"
        stroke-miterlimit="3.86874"
        stroke-linejoin="round"
        stroke-dasharray="10 10"
      />
      <line
        x1="115"
        y1="158"
        x2="84"
        y2="158"
        stroke="#FF8E8E"
        stroke-width="11"
        stroke-miterlimit="3.86874"
        stroke-linejoin="round"
        stroke-dasharray="10 10"
      />
      <line
        x1="85.751"
        y1="114.092"
        x2="126.094"
        y2="73.7489"
        stroke="#56CDFF"
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="156.5"
        cy="42.5"
        r="38.5"
        fill="white"
        stroke="#56CDFF"
        stroke-width="8"
      />
      <line
        x1="147.364"
        y1="34"
        x2="165"
        y2="51.636"
        stroke="#56CDFF"
        stroke-width="9"
        stroke-linecap="round"
      />
      <line
        x1="148"
        y1="51.636"
        x2="165.636"
        y2="34"
        stroke="#56CDFF"
        stroke-width="9"
        stroke-linecap="round"
      />
      <circle
        cx="42.5"
        cy="42.5"
        r="38.5"
        fill="white"
        stroke="#66DC95"
        stroke-width="8"
      />
      <circle
        cx="42.5"
        cy="156.5"
        r="38.5"
        fill="white"
        stroke="#A5A5A5"
        stroke-width="8"
      />
    </svg>
  );
}

DownloadIcon.defaultProps = {
  width: 24,
};

ExportIcon.defaultProps = {
  width: 24,
};
LoadingIcon.defaultProps = {
  height: 4,
  width: 16,
};

CaretDown.defaultProps = {
  width: 24,
};

ExpandIcon.defaultProps = {
  width: 24,
  isexpanded: false,
};

AccountManagementIcon.defaultProps = {
  width: 24,
};

SettingsIcon.defaultProps = {
  width: 24,
};

const BatteryIcon = props => {
  const { color } = props;
  return (
    <svg
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="1" width="7" height="9" rx="1" fill={color} />
      <rect x="2" width="3" height="2" rx="0.4" fill={color} />
    </svg>
  );
};

BatteryIcon.defaultProps = {
  color: '#FFFFFF',
};

export {
  ExportIcon,
  DownloadIcon,
  LoaderIcon,
  LoginIcon,
  LoadingIcon,
  CaretDown,
  ExpandIcon,
  BackIcon,
  AccountManagementIcon,
  SettingsIcon,
  NewLoaderIcon,
  NoStepsIcon,
  BatteryIcon,
};
